import { useState, useRef, useEffect, useMemo } from 'react'
import { colors, font, text, radius, sx } from '../design/tokens'

// Filtro multi-selección con desplegable de valores reales (facetas) + buscador
// interno para listas largas. Aplica al cerrar/Aplicar. Reutilizable en el BI.
//   options: array de strings, o de { value, label }
//   selected: array de values · onChange(nuevoArray)
export default function MultiSelectFiltro({ label, options = [], selected = [], onChange }) {
  const [open, setOpen] = useState(false)
  const [pend, setPend] = useState(selected)
  const [q, setQ] = useState('')
  const ref = useRef(null)

  // Normaliza a { value, label }
  const opts = useMemo(
    () => options.map((o) => (typeof o === 'object' ? o : { value: o, label: o })),
    [options]
  )

  useEffect(() => { setPend(selected) }, [selected, open])

  useEffect(() => {
    if (!open) return
    const fuera = (e) => { if (ref.current && !ref.current.contains(e.target)) cerrar() }
    document.addEventListener('mousedown', fuera)
    return () => document.removeEventListener('mousedown', fuera)
  }, [open, pend]) // eslint-disable-line react-hooks/exhaustive-deps

  const cerrar = () => { onChange(pend); setOpen(false); setQ('') }
  const toggle = (v) => setPend((p) => (p.includes(v) ? p.filter((x) => x !== v) : [...p, v]))

  const filtradas = q
    ? opts.filter((o) => String(o.label).toLowerCase().includes(q.toLowerCase()))
    : opts
  const n = selected.length

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button onClick={() => (open ? cerrar() : setOpen(true))} style={{ ...st.btn, ...(n ? st.btnOn : {}) }}>
        {label}{n > 0 && <span style={st.badge}>{n}</span>}
        <span style={{ color: colors.textMeta, fontSize: 9 }}>▾</span>
      </button>

      {open && (
        <div style={st.pop}>
          {opts.length > 10 && (
            <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar…" style={st.search} />
          )}
          <div style={st.list}>
            {filtradas.length === 0 && <div style={{ padding: 8, color: colors.textMeta, fontSize: text.sec }}>Sin coincidencias</div>}
            {filtradas.map((o) => (
              <label key={o.value} style={st.opt}>
                <input type="checkbox" checked={pend.includes(o.value)} onChange={() => toggle(o.value)} />
                <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{o.label}</span>
              </label>
            ))}
          </div>
          <div style={st.foot}>
            <button onClick={() => setPend([])} style={st.linkBtn}>Limpiar</button>
            <button onClick={cerrar} style={st.aplicar}>✓ Aplicar</button>
          </div>
        </div>
      )}
    </div>
  )
}

const st = {
  btn: { display: 'inline-flex', alignItems: 'center', gap: 6, padding: '7px 10px', borderRadius: radius.sm, border: `1px solid ${colors.border}`, background: colors.bg, color: colors.textSec, fontSize: text.sec, fontFamily: font.sans, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' },
  btnOn: { borderColor: colors.link, color: colors.link, background: colors.linkBg },
  badge: { ...sx.mono, background: colors.link, color: '#fff', fontSize: 10, fontWeight: 700, borderRadius: 999, minWidth: 16, height: 16, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '0 4px' },
  pop: { position: 'absolute', top: '100%', left: 0, marginTop: 4, zIndex: 50, background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: radius.md, boxShadow: '0 6px 20px rgba(15,23,42,0.12)', width: 240, padding: 6 },
  search: { width: '100%', boxSizing: 'border-box', padding: '6px 8px', border: `1px solid ${colors.border}`, borderRadius: radius.sm, fontSize: text.sec, marginBottom: 4, fontFamily: font.sans },
  list: { height: 260, overflowY: 'auto' },
  opt: { display: 'flex', alignItems: 'center', gap: 8, padding: '5px 6px', fontSize: text.body, color: colors.text, fontFamily: font.sans, cursor: 'pointer', borderRadius: radius.xs },
  foot: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: `1px solid ${colors.borderSoft}`, marginTop: 4, paddingTop: 6 },
  linkBtn: { border: 'none', background: 'transparent', color: colors.textSec, fontSize: text.sec, cursor: 'pointer', fontFamily: font.sans },
  aplicar: { border: `1px solid ${colors.link}`, background: colors.link, color: '#fff', fontSize: text.sec, fontWeight: 600, padding: '5px 12px', borderRadius: radius.sm, cursor: 'pointer', fontFamily: font.sans },
}
